<form [formGroup]="getTeamSubscriptionForm()" class="d-flex flex-column custom-modal-content">
    <div class='my-5'>
            <app-input-field [valueUpdate]='valueUpdate' [parentForm]='getTeamSubscriptionForm()' [inputJson]='teamIdFieldObject'>
            </app-input-field>
    </div>
</form>